<template>
  <FlexibleModal
    title-text="ご注意事項（必ずご一読ください）"
    primary-button-text="ギフトカードリスト作成にすすむ"
    :primary-button-disabled="!agreed"
    cancel-button-text="申込みをやめる"
    @clicked-primary="onClickCreateGiftCard"
    @clicked-cancel="onClickCancelBulkOrder"
  >
    <div class="bulk-personal-order-agreement-modal">
      <div class="bulk-personal-order-agreement-modal__description mb-24">
        <div>
          <p class="caption-black-bold">
            【お申し込みの条件について】
          </p>
          <ul class="bulk-personal-order-agreement-modal__list">
            <li class="bulk-personal-order-agreement-modal__list--item">
              まとめてオーダーは、ギフトカードの合計発行数が
              <span class="bulk-personal-order-agreement-modal__bold">
                11件以上
              </span>
              の場合にお申し込みいただけます。
            </li>
            <li class="bulk-personal-order-agreement-modal__list--item">
              <span class="bulk-personal-order-agreement-modal__red-bold">
                法人でのご利用の場合は、本フォームからお申し込みいただくことはできません。
              </span>
              <a href="https://giftee.biz/inquiry/" target="_blank">こちら</a>
              よりお問い合わせください。
            </li>
          </ul>
        </div>
        <div>
          <p class="caption-black-bold">
            【お申し込みいただける商品について】
          </p>
          <ul class="bulk-personal-order-agreement-modal__list">
            <li class="bulk-personal-order-agreement-modal__list--item">
              <span class="bulk-personal-order-agreement-modal__bold">
                お申し込み完了時点で、ご希望商品の購入は確約されておりません。
              </span>
              商品の在庫不足など、何らかの理由で購入が難しい場合は、お申し込み内容について追ってご相談をさせていただくことがございます。
            </li>
          </ul>
        </div>
        <div>
          <p class="caption-black-bold">
            【お支払い方法について】
          </p>
          <ul class="bulk-personal-order-agreement-modal__list">
            <li class="bulk-personal-order-agreement-modal__list--item">
              <span class="bulk-personal-order-agreement-modal__bold">
                指定の口座への銀行振り込み
              </span>
              をお願いしております。指定口座は三菱UFJ銀行です。振込手数料はお客様のご負担となります。
            </li>
            <li class="bulk-personal-order-agreement-modal__list--item">
              請求書を発行してから
              <span class="bulk-personal-order-agreement-modal__bold">
                5営業日以内のご入金
              </span>
              をお願いしております。期限を過ぎた場合は、お申し込みはキャンセルとさせていただきます。
            </li>
            <li class="bulk-personal-order-agreement-modal__list--item">
              入金後にお客様のご都合でお申し込みをキャンセルされ返金が発生する場合、振込手数料はお客様負担となります。
            </li>
          </ul>
        </div>
        <div>
          <p class="caption-black-bold">
            【発行したギフトカードについて】
          </p>
          <ul class="bulk-personal-order-agreement-modal__list">
            <li class="bulk-personal-order-agreement-modal__list--item">
              <span class="bulk-personal-order-agreement-modal__bold">
                入金が確認できてから原則3営業日以内
              </span>
              にお渡しします。
            </li>
            <li class="bulk-personal-order-agreement-modal__list--item">
              発行後は、お申し込みのキャンセルはできません。
            </li>
            <li class="bulk-personal-order-agreement-modal__list--item">
              発行したギフトカードURLは、
              <span class="bulk-personal-order-agreement-modal__bold">
                CSVファイル
              </span>
              でお渡しします。
            </li>
          </ul>
        </div>
        <div>
          <p class="caption-black-bold">
            【その他】
          </p>
          <ul class="bulk-personal-order-agreement-modal__list">
            <li class="bulk-personal-order-agreement-modal__list--item">
              登録情報入力時、誤まって他者の情報を入力したことによって生じた損害の一切について、ギフティは債務不履行責任、不法行為責任を含む一切の責任を負わず、お申し込み者様がすべて責任を負うこととなります。これに関して当社に一切の請求を行わないようお願いいたします。
            </li>
          </ul>
        </div>
      </div>
      <p
        class="minimal-black bulk-personal-order-agreement-modal__agreement-note"
      >
        上記注意事項および<a
          href="https://giftee.com/terms_of_service"
          target="_blank"
        >
          利用規約
        </a>
        ・
        <a href="https://giftee.com/privacy_policy" target="_blank">
          プライバシーポリシー
        </a>
        に同意の上、お申し込みください。
      </p>
      <label
        for="agreement_check"
        class="bulk-personal-order-agreement-modal__agreement-check"
      >
        <div
          :class="{
            checkbox: !agreed,
            'checkbox--checked': agreed
          }"
        >
          <input
            id="agreement_check"
            :value="agreed"
            type="checkbox"
            @change="onChangeBulkOrderAgreement"
          />
          同意する
        </div>
      </label>
    </div>
    <form
      class="bulk-order-agreement__cancel-form"
      name="cancelBulkOrderForm"
      method="post"
      action="/bulk_order"
    >
      <input type="hidden" name="authenticity_token" :value="csrfToken" />
      <input
        type="hidden"
        name="bulk_order_delete_form[referrer_url]"
        :value="referrer"
      />
      <input type="hidden" name="_method" value="DELETE" />
    </form>
  </FlexibleModal>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import FlexibleModal from '../../molecules/modals/flexible-modal.vue'
import { useBulkPersonalOrderSessionStore } from '../../../store/bulkPersonalOrderSessionStore'

const agreed = ref(false)
const referrer = ref('')

const props = defineProps({
  bulkPersonalOrderSessionId: {
    type: Number,
    required: true
  }
})

const csrfToken = document
  .querySelector('meta[name="csrf-token"]')
  .getAttribute('content')

const emit = defineEmits(['click-create-gift-card'])

const sessionStore = useBulkPersonalOrderSessionStore()
const { agree } = sessionStore

onMounted(() => {
  dataLayer.push({
    event: 'view_bulk_precautions_modal',
    bulk_personal_order_session_id: props.bulkPersonalOrderSessionId
  })

  // 遷移元が自分の場合は、リファラ情報を渡さないように
  referrer.value =
    document.referrer !== window.location.href ? document.referrer : ''
})

const onClickCreateGiftCard = () => {
  emit('click-create-gift-card')
  agree()
}

const onClickCancelBulkOrder = () => {
  document.cancelBulkOrderForm.submit()
}

const onChangeBulkOrderAgreement = () => {
  agreed.value = !agreed.value
}
</script>

<style lang="scss" scoped>
.bulk-personal-order-agreement-modal {
  font-size: 1.2rem;
  line-height: 1.6;
  text-align: left;

  &__description {
    height: 200px;
    overflow-y: scroll;
    overscroll-behavior-y: contain;

    & > * {
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__list {
    padding-left: 6px;

    &--item {
      list-style: inside;
    }
  }

  &__bold {
    font-weight: bold;
  }

  &__red-bold {
    color: $danger;
    font-weight: bold;
  }

  &__agreement-note {
    margin-bottom: 8px;
  }

  &__agreement-check {
    display: inline-block;
    margin-bottom: 24px;
  }

  &__cancel-form {
    display: none;
  }
}
</style>
